import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cebeb86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M437.5 953.1H221.4c-35.4-0.7-65-12.9-88.9-36.8-23.9-23.9-36.2-53.9-36.8-89.9V189.8c0.6-35.4 12.8-65 36.4-88.9s53.4-36.2 89.4-36.8h283.9l312.4 278v148.4h-60.9V368.6L481.7 123.9H221.4c-19 0.7-34.6 7.2-46.7 19.6-12.1 12.4-18.5 27.8-19.2 46.2v636.6c0.6 19 7.2 34.7 19.6 47.2 12.4 12.4 27.8 19 46.2 19.6h216.1l0.1 60z m168-378.2h-335c-8.5-0.6-15.6-3.8-21.1-9.3-5.6-5.6-8.4-12.6-8.4-21.1s2.8-15.6 8.4-21.1c5.6-5.6 12.6-8.7 21.1-9.3h335c8.5 0.7 15.5 3.8 21.1 9.3 5.6 5.6 8.4 12.6 8.4 21.1s-2.8 15.6-8.4 21.1c-5.5 5.5-12.6 8.6-21.1 9.3z m-96.3 143.4H270.5c-8.5-0.6-15.6-3.8-21.1-9.3-5.6-5.6-8.4-12.6-8.4-21.1s2.8-15.6 8.4-21.1c5.6-5.6 12.6-8.7 21.1-9.3h238.7c9.2 0.7 16.5 3.8 22.1 9.3 5.6 5.6 8.4 12.6 8.4 21.1s-2.9 15.6-8.8 21.1c-6 5.6-13.2 8.7-21.7 9.3z m278.1-333H463.1V94.5H524v230.9h263.3v59.9zM510.2 960c-7.9 0-14.7-2.9-20.6-8.8-7.2-7.2-10.2-15.7-8.8-25.5l15.7-109.1c2-12.4 7.5-23.6 16.7-33.4l245.6-245.6c14.4-13.8 30.5-21.9 48.1-24.6 21.6-2.6 39.6 2.9 54 16.7l50.1 50.1c13.8 14.4 19.3 32.1 16.7 53.1-2.6 18.3-10.8 34.7-24.6 49.1L656.6 927.6c-9.2 9.2-20 14.7-32.4 16.7l-114 15.7z m45.2-133.6l-9.8 67.8 68.8-9.8L860 638.7c3.3-3.3 5.6-6.5 6.9-9.8 1.3-3.3 1.6-5.6 1-6.9l-49.1-50.1c-1.3 0-3.6 0.5-6.9 1.5-3.3 1-6.6 3.4-9.8 7.4L555.4 826.4z m296.7-106.1c-7.9 0-15.1-2.9-21.6-8.8L729.3 610.2c-5.9-6.5-8.8-13.8-8.8-21.6 0-7.9 3.1-14.9 9.3-21.1 6.2-6.2 13.3-9.3 21.1-9.3 7.9 0 15.1 2.9 21.6 8.8l100.2 101.2c5.9 6.6 8.8 13.8 8.8 21.6 0 7.9-2.9 14.9-8.8 21.1-5.9 6.3-12.7 9.4-20.6 9.4z" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { ref } from 'vue'
import { parseCustomerInfo } from '@/api/common'
import { message } from '@dc-platform/dc-components'


const __default__ = { name: 'CustomerInfoParse' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { emit: __emit }) {


const emit = __emit
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const form = ref<any>({})
const showModal = () => {
  form.value = {}
  visible.value = true
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    parseCustomerInfo(form.value)
      .then((res) => {
        // "province": "河北省",
        //     "town": "高邑镇",
        //     "city": "石家庄市",
        //     "person": "杜先生",
        //     "county": "高邑县",
        //     "phoneNum": "15373841742",
        //     "detail": "4您所做的品类及平台temu 5您的需求及日均单量100单左右"
        if (res && res.code === 200) {
          if (!res.data || JSON.stringify(res.data) === '{}') {
            message.error('未识别到，请重试！')
            loading.value = false
            return
          }
          const { province, city, county, town, phoneNum, person } = res.data
          let remark = form.value.text.toString()
          if (person) {
            remark = remark.replace(RegExp(person, 'g'), '')
          }
          if (phoneNum) {
            remark = remark.replace(RegExp(phoneNum, 'g'), '')
          }
          const address = `${province}${city}${county}${town}`
          emit('success', {
            address,
            contactName: person,
            phoneNum,
            detail: remark
          })
        }
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", {
        viewBox: "0 0 1024 1024",
        class: "color-icon",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        onClick: showModal
      }, _hoisted_3))
    ]),
    _createVNode(_component_cos_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      title: "信息提取",
      width: "600px",
      onOk: handleSubmit,
      confirmLoading: loading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          "wrapper-col": { span: 24 },
          ref_key: "formRef",
          ref: formRef,
          model: form.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "内容",
              name: "text",
              rules: [{ required: true, message:'请输入内容' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: form.value.text,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.text) = $event)),
                  placeholder: "请粘贴内容，系统自动提取",
                  style: {"height":"150px","text-align":"start"}
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"])
  ], 64))
}
}

})